import twLocale from 'element-ui/lib/locale/lang/zh-TW'

export default {
    app: {
        title: '文獻相似性檢測服務',
        alias: '查大同 · 識小異',
        simple: '簡明報告',
        origin: '原文標註報告',
        detail: '詳細片段報告',
        full: '全文比對報告',
        preservation: '存檔報告'
    },
    info: {
        paperInfo: '送檢文獻信息',
        title: '【題名】',
        author: '作者',
        name: '姓名',
        stuNum: '學號',
        tutor: '導師',
        origin: '來源',
        receive: '收稿時間',
        receive2: '學位授予時間',
        checkTime: '檢測時間',
        checkLimit: '檢測範圍',
        allPerc: '總相似比',
        referenceCopyPercent: '參考文獻相似比',
        selfCopyPercent: '可能自引相似比'
    },
    cr: {
        result: '檢測結果',
        word: '字',
        jian: '檢',
        can: '參',
        zi: '自',
        fa: '法',
        zhuan: '專',
        validTextNum: '原文總字符數',
        fullTextNum: '檢測字符數',
        refCopyPer: '參考文獻相似比',
        exRefCopyPer: '輔助排除參考文獻相似比',
        selfCopyPer: '可能自引相似比',
        exSelfCopyPer: '輔助排除可能自引相似比',
        lawsCopyPer: '法律法規文獻相似比',
        exLawsCopyPer: '輔助排除法律法規相似比',
        termsCopyPer: '專名術語相似比'
    },
    crd: {
        detailResult: '詳細檢測結果',
        paraNum: '原文總段落數',
        simiCount: '相似字符數',
        maxSimiScale: '單篇最大相似比',
        maxSimiNum: '單篇最大相似字符數',
        maxSimiTitle: '單篇最大相似文獻',
        no: '無',
        tableNum: '識別表格數'
    },
    explain: {
        seal: '蓋章處',
        reportIndex: '報告指標說明',
        indicators1: '原文總字符數：即送檢文獻的總字符數，包含文字字符、標點符號、阿拉伯數字（不計入空格）',
        indicators2: '檢測字符數：送檢文獻經過系統程序處理，排除已識別的參考文獻等不作為相似性比對內容的部分後，剩余全部參與相似性檢測匹配的文本字符數',
        indicators3: '總相似比：送檢文獻與其他文獻的相似文本內容在原文中所占比例',
        indicators4: '參考文獻相似比：送檢文獻與其標明引用的參考文獻的相似文本內容在原文中所占比例',
        indicators5: '可能自引相似比：送檢文獻與其作者本人的其他已公開或發表文獻的相似文本內容在原文中所占比例',
        indicators6: '單篇最大相似比：送檢文獻的相似文獻中貢獻相似比最高壹篇的相似比值',
        indicators7: '引用情況：該相似文獻是否被送檢文獻標註為其參考文獻引用，以及是否為可能自引文獻。',
        indicators8: '法律法規文獻相似比：送檢文獻與“中國法律法規數據庫”中文獻的相似文本內容在原文中所占比例（新增內容）',
        indicators9: '專名術語相似比：相似文本中，「專用名詞和專業術語」在原文中所占比例'
    },
    full: {
        colorIntro: '報告顏色標註說明',
        green: '綠色',
        refCopyPer: '代表參考文獻相似比',
        yellow: '黃色',
        selfCopyPer: '代表可能自引相似比',
        red: '紅色',
        other: '代表除參考文獻及可能自引外的其他相似比',
        blue: '藍色',
        lawCopyPer: '代表法律法規文獻相似比',
        wfbc: '代表相似比',
        clickIntro: '請點擊文檔中有顏色標註的文本內容查看相似片段詳情',
        isRef: '是否引用',
        yes: '自引',
        no: '未引用',
        refCited: '參考文獻引用',
        similarPart: '相似文獻片段',
        partSimiNum: '此片段相似字符數',
        reportId: '報告編號',
        originMark: '原文標註',
        unfold: '展開',
        fold: '收起'
    },
    fOrH: {
        intro: '檢測報告由萬方數據文獻相似性檢測系統算法生成，僅對您所選擇的檢測範圍內檢驗結果負責，結果僅供參考',
        web: '萬方檢測官方網站',
        truth: '檢測報告真偽驗證官方網站',
        wf: '北京萬方數據股份有限公司出品',
        oneReport: '壹對壹檢測報告',
        downReport: '下載此報告',
        downing: '報告下載中，請耐心等待'
    },
    sign: {
        org: '檢測機構（蓋章）',
        signature: '簽字處',
        subMan: '提交人',
        subOrg: '提交人所在單位',
        isWf: '送檢論文是否為萬方數據庫內查找',
        inspector: '檢索檢測員',
        monitors: '監督員'
    },
    simi: {
        simiList: '相似文獻列表',
        listCount: '僅列舉前{len}條',
        index: '序號',
        perc: '相似比(相似字符)',
        simiPaper: '相似文獻',
        type: '類型',
        isRef: '引用情況',
        char: '字符',
        simiChart: '相似片段分布圖',
        simiDetail: '相似片段詳情',
        originPart: '送檢原文片段',
        position: '位置'
    },
    one: {
        thanInfo: '比對文獻信息',
        indicators1: '比對文獻是否為參考文獻：該比對文獻是否被送檢文獻標註為其參考文獻引用',
        indicators2: '比對文獻是否可能為自引文獻：比對文獻作者是否與送檢文獻作者一致',
        thanPart: '比對文獻片段'
    },
    error: {
        text1: '抱歉！您訪問的頁面不存在',
        text2: '請檢查網址是否正確'
    },
    ...twLocale
}